import { getUserV2 } from "@/api/requests/users";
import { useAddonStore } from "@/stores/add-ons/index.store";
import { useBusinessStore } from "@/stores/businesses.store";
import { useTokenStore } from "@/stores/token.store";
import { useUsersStore } from "@/stores/users.store";
import { useRouter } from "vue-router";
import { FullBusinessProfile } from "./types/business";

export function useFreeLiveCallRedirection() {
  const userStore = useUsersStore();
  const businessStore = useBusinessStore();
  const router = useRouter();
  const tokenStore = useTokenStore();

  async function handleTokenRedirection(token: string) {
    tokenStore.token = token;
    const response = await getUserV2();

    userStore.setCurrentUser({
      ...userStore.currentUserBusinessLevel,
      ...response.data,
    });

    businessStore.businesses = userStore?.profiles;

    await setActiveBusiness();
    userStore.user_role = "owner";

    await redirectToAppropriatePage();
  }
  async function setActiveBusiness() {
    if (businessStore.businesses?.length && !businessStore.activeBusiness) {
      // Sets the first element in the array as the active business if none exists
      businessStore.activeBusiness = businessStore
        .businesses[0] as FullBusinessProfile;
      await businessStore.fetchExtraBusinessDetails();
    }
  }
  async function redirectToAppropriatePage() {
    const freeTrialData = userStore.currentUserBusinessLevel?.free_trial_data;

    if (freeTrialData?.is_free_trial_user) {
      if (freeTrialData.is_developer) {
        await router.replace("/developers/dashboard");
      } else {
        await router.replace("/add-on/live-call-free-widget/welcome");
      }
    }
  }
  return {
    handleTokenRedirection,
  };
}

export const listProgramFeatures = [
  {
    title: "Website Live Call",
    description:
      "Integrate PressOne Live Call to allow your customers talk without leaving your platform.",
    img: "/assets/Images/developer-program/live-call.svg",
    isAvailable: true,
    to: "/developers/live-call-widget",
  },
  {
    title: "Voice OTP",
    description:
      "Integrate PressOne Voice OTP to enable secure voice calls for user authentication.",
    img: "/assets/Images/developer-program/voice-otp.svg",
    isAvailable: true,
    to: "/developers/voice-otp",
  },
  {
    title: "Call SDK",
    description:
      "Have PressOne functionality in your app. Make and receive calls, manage contacts and notes.",
    img: "/assets/Images/developer-program/full-widget.svg",
    isAvailable: false,
    to: "",
  },
];

export const listAvailableAddOneatures = [
  {
    title: "Website Live Call",
    description:
      "This add-on allows customers to initiate real-time calls directly from a website, enhancing customer support through instant communication.",
    img: "/assets/Images/icons/live-widget.svg",
    isSubscribed: true,
    to: "/developers/live-call-widget",
  },
  {
    title: "Voice OTP",
    description:
      "This add-on will enable you to send automated one-time passwords to your customers for verification purposes via voice calls.",
    img: "/assets/Images/icons/voice-otp.svg",
    isSubscribed: true,
    to: "/developer/voice-otp",
  },
];
export const getVoiceOTPId = () => {
  const addonStore = useAddonStore();
  const getLiveCallSub = addonStore.getSubscribedAddons?.find(
    (addon) => addon.subscription_plan?.title === "Voice OTP Addon"
  );
  return getLiveCallSub?.id;
};
